import axios from "axios";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { mockUserCookies, mockUserProfile } from "src/mocks/userProfile";
import appState from "src/model/state";
import { UserProfile } from "src/model/state/partials/profile.model";
import { getCountryLanguage } from "src/utils/BasePathTools";
import { getEnv } from "src/utils/EnvironmentTools";
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";
import { getAuthHeader, getUserFromCookies } from "src/utils/TokenTools";
import { deleteOvixiaToken } from "src/utils/utils";

const TS_CACHE = 600000;
const URL = '/itxrest/1/user/store/{id}/profile?languageId={langId}';

export const goToLogin = (url: string) => {
    const cancelUrl = `${window.location.origin}${getCountryLanguage()}preowned-resell/products`
    window.location.href = `${getCountryLanguage()}reselling/login?returnUrl=${encodeURIComponent(url)}&cancelUrl=${encodeURIComponent(cancelUrl)}`;
}

const fetchProfile = async () => {
    const { shopLangId, shopId } = useShop()
    const url = URL.replace('{id}', shopId.toString()).replace('{langId}', shopLangId.toString());
    const currentcook = document.cookie.split("; ");
    (window as any).currentCook = currentcook;
    (window as any).currentProfileHeader =  getAuthHeader();

   
    const response = await axios(`${getEnv()?.zaraHost}${url}`, {
        withCredentials: true,
        headers: getAuthHeader() 
      });
    return response?.data as Promise<UserProfile>;
}

export const getProfile = async (forceRefresh?: boolean) => {
  const { profile } = appState.get();
  const { shopMarketId } = useShop();
  if (!forceRefresh && profile.loaded && profile.lastLoad > Date.now() - TS_CACHE) {
    return;
  }

  const userFromCookies = {user_type : getUserFromCookies()?.user_type, user_id: getUserFromCookies()?.user_id};

  if (window.location.hostname === "localhost") {
    appState.execute("PRF_SET", { user: mockUserProfile, userFromCookies: mockUserCookies,});
  } else {
    if (getUserFromCookies()?.user_type?.toLowerCase() !== "guest") {
      let user: UserProfile = null;

      try {
        const user = await fetchProfile();
        const customerData =
          await OpenapiSingleton.BuyerPersonalDataAPIApi.get1(shopMarketId);
        if (
          customerData?.data?.firstName === user.firstName &&
          customerData?.data?.lastName === customerData?.data?.lastName
        ) {
          // user correctly logged
          appState.execute("PRF_SET", { user: user, userFromCookies: userFromCookies,});
        } else {
          appState.execute("PRF_NEEDS_LOGIN", undefined); // needs to update user token to match Zara's login
        }
      } catch (error: any) {
        if (error) {
          const status = error?.response?.status;
          if (status === 403 || status === 401) {
            if (user) {
              // user logged in Zara
              appState.execute("PRF_NEEDS_LOGIN", undefined);
              return;
            } else {
              // delete token to avoid authenticating the user against the RESELL api
              deleteOvixiaToken();
              appState.execute("PRF_SET", { user: null, userFromCookies: profile?.userFromCookies, });
              return;
            }
          }
        }
        appState.execute("PRF_SET_ERROR", "GETTING_PROFILE");
      }
    } else {
      deleteOvixiaToken();
      appState.execute("PRF_SET", { user: null, userFromCookies: userFromCookies, });
      return;
    }
  }
};

export const authenticate = () => {
    const { profile } = appState.get();
    if (!profile.loaded) {
        appState.execute("PRF_SET_LOADING", true);
    }
    getProfile();
}

export const forceLogin = () => {
    appState.execute("PRF_NEEDS_LOGIN", undefined);
}

export const forceLoginIfNeeded = () => {
    if (appState.get().profile.user === null) {
        forceLogin();
        return true;
    }

    return false;
}

export const setSessionExpired = () => {
    appState.execute("PRF_SESSION_EXPIRED", undefined);
}

export const continueAsGuest = () => {
    const userFromCookies = {user_type : getUserFromCookies()?.user_type, user_id: getUserFromCookies()?.user_id};
    appState.execute("PRF_SET", {user: null, userFromCookies: userFromCookies});
}